import { translatableValidator } from '@vista-digital/ocapi-utilities';
import { Validator } from '@vista-digital/validator';
export const customFilmActionValidator = Validator.object({
    title: translatableValidator,
    message: Validator.optional(translatableValidator),
    iconName: Validator.optional(Validator.nonEmptyString),
    href: Validator.optional(Validator.nonEmptyString),
    onClick: Validator.optional(Validator.fn())
});
//# sourceMappingURL=custom-film-action.js.map